// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"48":"ba6aed67","229":"f40ab91b","265":"2801187f","297":"d30b5626","643":"a0fbe6f3"}[chunkId] + ".chunk.js";
};